import React from "react";
import { TIER_META, fmtUsd } from "../../data/casesData";
import { Button } from "../ui/button";
import ItemImage from "./ItemImage";
import { Package, DollarSign, Truck, Sparkles, RotateCw } from "lucide-react";

export default function ItemResultPanel({ item, onKeep, onSell, onShip, onSpinAgain, canSpinAgain, price, accent }) {
  const meta = TIER_META[item.tier];
  const c = meta.color;
  return (
    <div className="relative overflow-hidden text-center py-4 px-2 result-pop" data-testid="item-result-panel"
      style={{ background: `radial-gradient(circle at 50% 30%, ${c}22, transparent 70%)` }}>
      <style>{`
        @keyframes rp-pop { 0% { transform: scale(.82); opacity: 0 } 60% { transform: scale(1.04) } 100% { transform: scale(1); opacity: 1 } }
        @keyframes rp-ring { 0% { transform: scale(.9); opacity: .7 } 100% { transform: scale(1.35); opacity: 0 } }
        @keyframes rp-float { 0%,100% { transform: translateY(0) } 50% { transform: translateY(-6px) } }
        .result-pop { animation: rp-pop .45s cubic-bezier(.2,.9,.3,1.2) both }
      `}</style>

      <div className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.3em] text-[#9AA0AE]">
        <Sparkles className="h-3.5 w-3.5" style={{ color: c }} /> You unboxed
      </div>
      <div className="mt-2 inline-block px-3 py-1 rounded-full text-[11px] font-extrabold uppercase tracking-wider"
        style={{ color: c, background: `${c}1f`, border: `1px solid ${c}55` }} data-testid="result-tier">{meta.label}</div>

      <div className="relative mx-auto my-5 h-44 w-44 flex items-center justify-center" style={{ animation: "rp-float 3s ease-in-out infinite" }}>
        <span className="absolute inset-0 rounded-full" style={{ border: `2px solid ${c}`, animation: "rp-ring 1.6s ease-out infinite" }} />
        <span className="absolute inset-0 rounded-full" style={{ border: `2px solid ${c}`, animation: "rp-ring 1.6s ease-out .6s infinite" }} />
        <div className="relative h-40 w-40 rounded-2xl flex items-center justify-center"
          style={{ background: `radial-gradient(circle at 50% 40%, ${c}2e, rgba(255,255,255,0) 72%)`, boxShadow: `0 10px 50px ${c}44` }}>
          <div className="h-28 w-28 rounded-xl overflow-hidden flex items-center justify-center bg-[#19142A] dark:bg-[#151B27] border border-[#2A2440] dark:border-[#2A2440] shadow-sm">
            <ItemImage item={item} imgClass="h-28 w-28" iconClass="h-14 w-14" color={c} />
          </div>
        </div>
      </div>

      <div className="font-heading text-2xl sm:text-3xl font-extrabold text-white dark:text-white leading-tight" data-testid="result-item-name">{item.name}</div>
      <div className="mt-2 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#16A34A]/12 border border-[#16A34A]/30" data-testid="result-item-value">
        <DollarSign className="h-3.5 w-3.5 text-[#16A34A]" />
        <span className="font-grotesk font-bold text-[#16A34A]">{fmtUsd(item.value)}</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-6">
        <Button data-testid="result-keep-btn" onClick={onKeep} variant="outline"
          className="w-full rounded-lg border-[#2A2440] dark:border-[#2A2440] text-white dark:text-white dark:bg-[#1E1832] hover:bg-[#19142A] dark:hover:bg-[#2A2440] gap-2 font-bold">
          <Package className="h-4 w-4" /> Keep
        </Button>
        <Button data-testid="result-sell-btn" onClick={onSell}
          className="w-full rounded-lg gap-2 bg-[#16A34A] hover:bg-[#15903f] text-white font-bold shadow-sm">
          <DollarSign className="h-4 w-4" /> Sell {fmtUsd(item.value)}
        </Button>
        <Button data-testid="result-ship-btn" onClick={onShip} variant="outline"
          className="w-full rounded-lg border-[#2A2440] dark:border-[#2A2440] text-white dark:text-white dark:bg-[#1E1832] hover:bg-[#19142A] dark:hover:bg-[#2A2440] gap-2 font-bold">
          <Truck className="h-4 w-4" /> Ship it
        </Button>
      </div>

      {onSpinAgain && (
        <Button data-testid="result-spin-again-btn" onClick={onSpinAgain} disabled={!canSpinAgain}
          className="w-full mt-2 h-12 rounded-lg gap-2 text-base font-bold font-heading text-white border-0 hover:opacity-95 disabled:opacity-40 disabled:cursor-not-allowed"
          style={{ background: canSpinAgain ? (accent || c) : "#C4C9D4" }}>
          <RotateCw className="h-4 w-4" /> {canSpinAgain ? `Spin Again — ${fmtUsd(price)}` : "Deposit to spin again"}
        </Button>
      )}
    </div>
  );
}
